import React, { useMemo } from "react";
import { string, bool } from "prop-types";
import { CpIcon } from "@components";
import { a } from "kremling";

export const CpNameChip = props => {
  const { name, className = "", active = false } = props;

  const initials = useMemo(() => {
    const sections = name?.split(" ") || [];
    const firstInitial = sections[0]?.charAt(0)?.toUpperCase();
    const lastInitial =
      sections.length > 1 &&
      sections[sections.length - 1]?.charAt(0)?.toUpperCase();

    return firstInitial && lastInitial ? (
      `${firstInitial}${lastInitial}`
    ) : (
      <CpIcon name="person" />
    );
  }, [name]);

  return (
    <div
      className={a(`cps-label-square +medium ${className}`).m(
        "+active",
        active
      )}
    >
      <div className="cps-center-vertical">{initials}</div>
    </div>
  );
};

CpNameChip.propTypes = {
  name: string,
  className: string,
  active: bool
};
